import { Reveal } from "@/lib/motion";
import { Ear, Lightbulb, ShieldCheck, ScanSearch, BookOpen, Handshake } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

const ICONS = [Ear, Lightbulb, ShieldCheck, ScanSearch, BookOpen, Handshake];

export default function WhyClientsTrust() {
  const c = useSiteContent().trust;
  return (
    <section id="trust" data-testid="trust-section" className="section-pad bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="md:max-w-3xl">
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-luxe text-[#1D1D1F] text-4xl md:text-5xl leading-[1.08] mt-5">
              {c.heading}
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {(c.cards || []).map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div data-testid={`trust-card-${i}`} className="border-t border-black/15 pt-8 pr-4">
                  <Icon size={26} strokeWidth={1.1} className="text-[#B68D40] mb-5" />
                  <h3 className="font-serif-luxe text-2xl text-[#1D1D1F] leading-tight">{it.title}</h3>
                  <p className="text-[#616161] text-sm leading-relaxed mt-3">{it.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
